module.exports = __webpack_public_path__ + "static/pink-arrow-right-eb7789b4fe3418779764e31a1c1bca44.webp";